var map = {
	"./cs.json": [
		39394,
		39394
	],
	"./de.json": [
		57155,
		57155
	],
	"./en.json": [
		13323,
		13323
	],
	"./es.json": [
		47580,
		47580
	],
	"./fr.json": [
		24144,
		24144
	],
	"./it.json": [
		87913,
		87913
	],
	"./ja.json": [
		96705,
		96705
	],
	"./ko.json": [
		8286,
		8286
	],
	"./pl.json": [
		71180,
		71180
	],
	"./pt-br.json": [
		80355,
		80355
	],
	"./pt.json": [
		37428,
		37428
	],
	"./ru.json": [
		1517,
		1517
	],
	"./tr.json": [
		56590,
		56590
	],
	"./zh.json": [
		18174,
		18174
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8053;
module.exports = webpackAsyncContext;